import { render } from "./idr_deposit_upload_file.vue?vue&type=template&id=645f09b8"
import script from "./idr_deposit_upload_file.vue?vue&type=script&lang=js"
export * from "./idr_deposit_upload_file.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__